import { ActivityConfigurations } from '../../registries/activity-configurations';
import { MappingActivityConfiguration } from './mapping-activity-configuration';

@ActivityConfigurations.register({})
export abstract class ContainerActivityConfiguration extends MappingActivityConfiguration {
}
